export default "__VITE_ASSET__dSSMT4Wj__"